import React, { useMemo, useContext } from "react";
import { useCategories } from "../utils/useCategories";
import loader from "../../assets/loader.webp";
import { AllProductContext } from "../../context/AllProductProvider";

function CategoryList({ setCategoryId }) {
  const { setAllProduct } = useContext(AllProductContext);
  const { data, isLoading } = useCategories();

  const categoryList = useMemo(
    () => {
      const bgColors = [
        "bg-red-100",
        "bg-yellow-100",
        "bg-green-100",
        "bg-blue-100",
        "bg-purple-100",
        "bg-pink-100",
      ];
      // The API returns either a plain array or a paginated { data: [...] }
      const allCategories = Array.isArray(data) ? data : data?.data;
      if (!Array.isArray(allCategories)) return null;

      // Only show categories that have products in them
      const categories = allCategories.filter(
        (category) =>
          !Array.isArray(category?.products) || category.products.length > 0
      );

      return categories.map((category, index) => {
        const bgColor = bgColors[index % bgColors.length];
        return (
          <div
            onClick={() => {
              setAllProduct(false);
              setCategoryId(category?.id);
            }}
            key={category?.id} //bg-gray-200 previous color
            className={`w-1/4 h-full shadow-md rounded-lg flex justify-center items-center hover:bg-opacity-80 cursor-pointer flex-none ${bgColor}`}
          >
            <h4 className="font-medium text-base text-black">
              {category?.cat_name}
            </h4>
          </div>
        );
      });
    },
    [data, setAllProduct, setCategoryId]
  );

  const loadingSpinner = useMemo(
    () => (
      <div className="w-full flex justify-center items-center">
        <img src={loader} alt="Loading..." className="w-8" />
      </div>
    ),
    []
  );

  return (
    <div className="flex flex-row px-3 pb-3 items-center">
      <div className="w-full">
        <div className="flex gap-4 items-center mt-3">
          <button
            onClick={() => setAllProduct(true)}
            className="p-3 py-2.5 font-medium rounded-lg text-white flex justify-center items-center hover:bg-gray-600 bg-gray-500"
          >
            All Products
          </button>
          {isLoading && loadingSpinner}
          <div className="w-full h-20 flex gap-2 p-2 overflow-x-auto scrollbar-thin py-3 scrollbar-thumb-gray-400 scrollbar-track-gray-100">
            {categoryList}
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(CategoryList);
